// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-title span{color:#40a9ff}", "",{"version":3,"sources":["webpack://./src/components/components/condo-weeks/condo-week-dates-table/style.scss"],"names":[],"mappings":"AAEI,iBACI,aAAA","sourcesContent":["\n.card-title {\n    span {\n        color: #40a9ff;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
